import OnboardingHiImMary from './components/OnboardingHiImMary.js';
import connect from './connect';
import './assets/OnboardingHiImMary.css';

export default connect(OnboardingHiImMary);



// WEBPACK FOOTER //
// ./src/routes/OnboardingHiImMary/index.js